import React from "react";
import { Circle } from "../atoms/Circle";

interface IStickAndCircleBlock {
  isBusHere: boolean; //если в данной точке находиться машина
  isClickedPoint: boolean; //эта точка, на которую нажали на карте
  isLast: boolean;
}

//отрисовываем кружок и вертикальную линию
export const StickAndCircleBlock = ({
  isBusHere,
  isClickedPoint,
}: IStickAndCircleBlock) => {
  return (
    <div className="route-li__circle">
      <Circle isClickedPoint={isClickedPoint} isBusHere={isBusHere} />
    </div>
  );
};
